module.exports = __webpack_public_path__ + "img/product-xjg-3338.7b72df4e.png";